module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "content-one"
  }, [_c('content-title', {
    attrs: {
      "title": "数据源"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("数据导入")]), _vm._v(" "), _vm._l((_vm.importWays), function(wayData) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.activeImportWayKey = wayData.key
        }
      }
    }, [(wayData.key === _vm.activeImportWayKey) ? _c('img', {
      attrs: {
        "src": require("assets/checked-2.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("assets/unchecked-2.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n              " + _vm._s(wayData.name) + "\n            ")]), _vm._v(" "), (wayData.key === 'local_file' && wayData.key === _vm.activeImportWayKey) ? _c('input', {
      staticStyle: {
        "margin-left": "4rem"
      },
      attrs: {
        "type": "file",
        "id": "file-1"
      },
      on: {
        "change": _vm.importf
      }
    }) : _vm._e(), _vm._v(" "), (wayData.key === 'local_file' && wayData.key === _vm.activeImportWayKey) ? _c('a', {
      staticClass: "output-btn-sm",
      attrs: {
        "href": "/static/ele_demo.xlsx",
        "download": "演示数据"
      }
    }, [_vm._v("演示数据下载")]) : _vm._e()])
  }), _vm._v(" "), _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goSourceDataPage
    }
  }, [_vm._v("导入")])], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-182db3c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/ele/ele_import.vue
// module id = 774
// module chunks = 1